<template>
  <div>
    <CCard>
      <CCardHeader class="pt-1 pb-1">
        <CRow>
          <CCol sm="8">
            <span class="card-header-title">Thống kê thu chi ngân sách</span>
          </CCol>
          <CCol sm="4">
            <CButtonGroup class="float-right mr-3">
              <CButton
                color="outline-warning"
                v-for="(value, key) in ['Tháng', 'Năm']"
                :key="key"
                class="mx-0"
                :pressed="value === selected ? true : false"
                @click="changeTypeReport(value)"
              >
                {{ value }}
              </CButton>
            </CButtonGroup>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody class="pt-2 pb-0">
        <CRow>
          <CCol sm="6">
            <CCard class="pb-0">
              <CCardHeader class="text-center pt-0 pb-0">
                <span class="card-header-title">Thu ngân sách</span>
              </CCardHeader>
              <b-overlay
                :show="!state.loading_revenue"
                no-wrap
                spinner-variant="success"
                spinner-type="grow"
                rounded="sm"
                opacity="0.8"
                z-index="1000"
              />
              <CChartLine style="height:300px" :datasets="data_revenues" :labels="data_label" :options="lineChartOptions" />
            </CCard>
          </CCol>
          <CCol sm="6">
            <CCard>
              <CCardHeader class="text-center pt-0 pb-0">
                <span class="card-header-title">Chi ngân sách</span>
              </CCardHeader>
              <b-overlay
                :show="!state.loading_pay"
                no-wrap
                spinner-variant="success"
                spinner-type="grow"
                rounded="sm"
                opacity="0.8"
                z-index="1000"
              />
              <CChartLine style="height:300px" :datasets="data_pays" :labels="data_label" :options="lineChartOptions"/>
            </CCard>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>

import ClientFactory from "@/api/ClientFactory";
import { CChartBar, CChartLine } from "@coreui/vue-chartjs";
const revenuesApi = ClientFactory.get("revenues");
const paysApi = ClientFactory.get("pays");

export default {
  components: {
    CChartBar,
    CChartLine
  },
  data() {
    return {
      selected: "Tháng",
      fromDate: new Date(),
      toDate: new Date(),
      data_revenues: [],
      data_pays: [],
      state: {
        loading_revenue: false,
        loading_pay: false,
      },
      data_label: [],
      
    };
  },
  methods: {
    getRevenues: async function() {
      this.state.loading_revenue = false;
      let params = {};
      params.year = new Date().getFullYear();
      params.type = this.selected == "Tháng" ? 1 : 2;
      const {data: [revenuesData]} = await revenuesApi.get_statical_year(params);
      let jsonSendDocuments = [
        {
          label: ["Thu nội địa"],
          borderColor: "rgb(240, 34, 40)",
          backgroundColor: '#00000000',
          pointBackgroundColor: "rgb(240, 34, 40)",
          data: revenuesData.total_internal,
        },
        {
          label: ["Thu qua hoạt động XNK"],
          borderColor: "rgb(246, 163, 19)",
          backgroundColor: '#00000000',
          pointBackgroundColor: "rgb(246, 163, 19)",
          data: revenuesData.total_imx,
        },
        {
          label: ["Thu ngân sách"],
          borderColor: "rgb(33, 146, 228)",
          backgroundColor: '#00000000',
          pointBackgroundColor: "rgb(33, 146, 228)",
          data: revenuesData.total_budget,
        },
      ];
      this.state.loading_revenue = true;
      this.data_revenues = jsonSendDocuments;
    },
    getPays: async function() {
      this.state.loading_pay = false;

      let params = {};
      params.year = new Date().getFullYear();
      params.type = this.selected == "Tháng" ? 1 : 2;
      const {data: [payData]} = await paysApi.get_statical_year(params);
      let jsonReceiveDocuments = [
        {
          label: ["Chi cân đối NS địa phương"],
          borderColor: "rgb(240, 34, 40)",
          backgroundColor: '#00000000',
          pointBackgroundColor: "rgb(240, 34, 40)",
          data: payData.total_localbudget,
        },
        {
          label: ["Chi CT MTQG,DA,nhiệm vụ khác"],
          borderColor: "rgb(33, 146, 228)",
          backgroundColor: '#00000000',
          pointBackgroundColor: "rgb(33, 146, 228)",
          data: payData.total_other,
        },
      ];
      this.state.loading_pay = true;
      this.data_pays = jsonReceiveDocuments;
    },
    changeTypeReport(value) {
      this.selected = value;
      if (value === "Năm") {
        this.data_label = this.data_label_nam;
      } else {
        this.data_label = this.data_label_thang;
      }
      this.getRevenues();
      this.getPays();
    },
  },
  created() {
    this.data_label = this.data_label_thang;
    this.getRevenues();
    this.getPays();
  },
  computed: {
    data_label_nam() {
      return [
        new Date().getFullYear() - 4,
        new Date().getFullYear() - 3,
        new Date().getFullYear() - 2,
        new Date().getFullYear() - 1,
        new Date().getFullYear(),
      ]
    },
    data_label_thang(){
      return [
        "Tháng một",
        "Tháng hai",
        "Tháng ba",
        "Tháng bốn",
        "Tháng năm",
        "Tháng sáu",
        "Tháng bảy",
        "Tháng tám",
        "Tháng chín",
        "Tháng mười",
        "Tháng mười một",
        "Tháng mười hai",
      ]
    },
    lineChartOptions() {
      return {
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          xAxes: [{
            display: true,
          }],
          yAxes: [{
            display: true
          }]
        },
        elements: {
          line: {
            borderWidth: 2
          },
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: function(tooltipItem, data) {
              return ` ${data.datasets[tooltipItem.datasetIndex].label[0]}: ${tooltipItem.yLabel} tỷ đồng`;
            },
          }
        }
      }
    }
  }
};
</script>
<style>
  .a {
    background: #000000;
  }
</style>
